var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',_vm._b({staticClass:"vertical-nav-menu-link",attrs:{"active-class":"bg-gradient-primary white--text"}},'v-list-item',_vm.$attrs,false),[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }